import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

/**
 * Compact empty state for cards, trees, and panels (no large illustration).
 */
export function SectionEmpty({
  title = 'No results',
  description = 'Try adjusting your filters or search.',
  icon = 'solar:inbox-line-bold-duotone',
  sx,
}) {
  return (
    <Stack alignItems="center" justifyContent="center" textAlign="center" spacing={1} sx={{ py: 4, px: 2, ...sx }}>
      <Iconify icon={icon} width={40} sx={{ color: 'text.disabled' }} />
      <Typography variant="subtitle2">{title}</Typography>
      {description ? (
        <Typography variant="body2" color="text.secondary" maxWidth={360}>
          {description}
        </Typography>
      ) : null}
    </Stack>
  );
}
